var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMajesticonsData({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.75 14.5833C43.75 19.1875 35.3542 22.9167 25 22.9167C14.6458 22.9167 6.25 19.1875 6.25 14.5833C6.25 9.97917 14.6458 6.25 25 6.25C35.3542 6.25 43.75 9.97917 43.75 14.5833Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.75 14.5833C43.75 19.1875 35.3542 22.9167 25 22.9167C14.6458 22.9167 6.25 19.1875 6.25 14.5833M43.75 14.5833C43.75 9.97917 35.3542 6.25 25 6.25C14.6458 6.25 6.25 9.97917 6.25 14.5833M43.75 14.5833V25M6.25 14.5833V25M43.75 25C43.75 29.6042 35.3542 33.3333 25 33.3333C14.6458 33.3333 6.25 29.6042 6.25 25M43.75 25V35.4167C43.75 40.0208 35.3542 43.75 25 43.75C14.6458 43.75 6.25 40.0208 6.25 35.4167V25",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMajesticonsData);
export default __webpack_public_path__ + "static/media/majesticons_data.f47e112037e3c2fe2dd6d2039537ebd8.svg";
export { ForwardRef as ReactComponent };